/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
// import '../styles/base.css';

//Importando jquery
const $ = require('jquery');

global.$ = global.jQuery = $;
window.jQuery = $;

require('parsleyjs');

window.bootstrap = require("bootstrap");

//Importando animaciones
import AOS from 'aos/dist/aos';
AOS.init();
